var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectArrowBL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.243,
    height: 8.239,
    viewBox: "0 0 12.243 8.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_11441",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 11441",
    transform: "translate(10.121 6.121) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_24",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 24",
    d: "M0,4,4.024,0,8,3.972",
    fill: "#f5f5f5",
    stroke: "#9299a2",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectArrowBL);
export default __webpack_public_path__ + "static/media/project-arrow_b-l.cd33674c69a33ef133f867de9e838710.svg";
export { ForwardRef as ReactComponent };